module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHeader),
      expression: "showHeader"
    }],
    class: {
      'pos_index': _vm.isIndex,
      'pos_results': _vm.isResults,
      'pos_personal': _vm.isPersonal,
      'pos_feedback': _vm.isFeedback
    }
  }, [_c('div', {
    staticClass: "h_container"
  }, [_c('div', {
    staticClass: "clearfix h_maincon_wrap",
    style: ({
      'display': _vm.$route.path == '/reset' ? 'none' : ''
    })
  }, [_c('router-link', {
    staticClass: "h_logo",
    attrs: {
      "to": "/"
    }
  }, [(_vm.isPersonal) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/common/logo_white.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/common/logo_black.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "h_search_box"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "MD"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.keyword),
      expression: "keyword",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "maxlength": "30",
      "autocomplete": "false"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/search_button.png")
    },
    on: {
      "click": _vm.search
    }
  })])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "h_user"
  }, [(_vm.hasLogin) ? _c('div', [_c('span', {
    staticClass: "login_account account_action",
    on: {
      "click": _vm.goPersonalCenter
    }
  }, [_vm._v(_vm._s(_vm.$store.state.user.loginAccount))]), _vm._v(" "), _c('span', {
    staticClass: "split"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "account_action",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])]) : _c('div', [_c('span', {
    staticClass: "account_action",
    on: {
      "click": function($event) {
        _vm.openPopup('loginWin')
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', {
    staticClass: "split"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "account_action",
    on: {
      "click": function($event) {
        _vm.openPopup('registerWin')
      }
    }
  }, [_vm._v("注册")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path == '/'),
      expression: "$route.path=='/'"
    }],
    staticClass: "header_bottom_line"
  }, [_c('div', {
    staticClass: "lightSpot"
  }), _vm._v(" "), _c('div', {
    staticClass: "lightSpotLine"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_truthso"
  }, [_c('div', {
    staticClass: "menu-down"
  }, [_c('a', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("关于真相"), _c('span', {
    staticClass: "menu-down-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-down-con"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "http://www.truthso.com/about/",
      "target": "_blank"
    }
  }, [_vm._v("真相科技")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.truthelectronic.com",
      "target": "_blank"
    }
  }, [_vm._v("真相电子")])])])]), _c('span', {
    staticClass: "splitS"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "href": "http://www.inic.org.cn/",
      "target": "_blank"
    }
  }, [_vm._v("中国互联网法治研究院")]), _c('span', {
    staticClass: "splitS"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "href": "https://www.legalxchain.com",
      "target": "_blank"
    }
  }, [_vm._v("legalXchain司法联盟链")]), _c('span', {
    staticClass: "splitS"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "href": "https://www.ip360.net.cn/",
      "target": "_blank"
    }
  }, [_vm._v("IP360全方位数据权益保护平台")]), _c('span', {
    staticClass: "splitS"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.xcontract.cn",
      "target": "_blank"
    }
  }, [_vm._v("Xcontract智能签约平台")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-185f9539"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SHeader.vue
// module id = 748
// module chunks = 1